import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/auth.css";

const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .vs-lang-list {
    display: flex;
    flex-direction: column;
    gap: 9px;
    margin-bottom: 26px;
  }
  .vs-lang-btn {
    padding: 14px 18px;
    background: var(--surface-2);
    border: 1.5px solid var(--border);
    border-radius: 12px;
    color: var(--text-2);
    font-family: var(--font-body);
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: all 0.2s ease;
    text-align: left;
  }
  .vs-lang-btn:hover {
    border-color: var(--border-strong);
    background: var(--accent-tint);
    color: var(--text);
  }
  .vs-lang-btn.active {
    border-color: var(--accent);
    background: var(--accent-tint);
    color: var(--text);
    font-weight: 600;
  }
  .vs-lang-flag { font-size: 22px; }
  .vs-lang-check {
    margin-left: auto;
    color: var(--accent);
    font-size: 15px;
    font-weight: 700;
  }

  .vs-auth-card{max-width:460px}
`;

function SelectLanguage() {
  const { t, i18n } = useTranslation();
  const navigate    = useNavigate();
  const [selected, setSelected] = useState("english");

  const languages = [
    { code: "english",   label: "English",   native: "English",   flag: "🇬🇧" },
    { code: "hindi",     label: "Hindi",     native: "हिंदी",       flag: "🇮🇳" },
    { code: "telugu",    label: "Telugu",    native: "తెలుగు",      flag: "🇮🇳" },
    { code: "tamil",     label: "Tamil",     native: "தமிழ்",       flag: "🇮🇳" },
    { code: "malayalam", label: "Malayalam", native: "മലയാളം",     flag: "🇮🇳" },
  ];

  useEffect(() => {
    const el = document.createElement("style");
    el.textContent = styles;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  const handleContinue = () => {
    i18n.changeLanguage(selected);
    localStorage.setItem("language", selected);
    // New user = never seen tutorial → go to tutorial first
    const tutorialDone = localStorage.getItem("vs_tutorial_done");
    if (!tutorialDone) {
      localStorage.setItem("vs_is_new_user", "1");
      navigate("/tutorial");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="vs-auth-page">
      <div className="vs-auth-card">
        <h1 className="vs-auth-logo">VaultSphere</h1>
        <p className="vs-auth-tagline">{t("chooseLanguage")}</p>

        <div className="vs-auth-divider">
          <div className="vs-auth-divider-line" />
          <div className="vs-auth-divider-dot" />
          <div className="vs-auth-divider-line" />
        </div>

        <div className="vs-lang-list">
          {languages.map(lang => (
            <button
              key={lang.code}
              className={`vs-lang-btn${selected === lang.code ? " active" : ""}`}
              onClick={() => setSelected(lang.code)}
            >
              <span className="vs-lang-flag">{lang.flag}</span>
              <span>{lang.native}</span>
              {selected === lang.code && <span className="vs-lang-check">✓</span>}
            </button>
          ))}
        </div>

        <button className="vs-auth-btn" onClick={handleContinue}>
          {t("continue")} →
        </button>
      </div>
    </div>
  );
}

export default SelectLanguage;